import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/ContentPage";
import { IMAGES } from "@/lib/images";

export const Route = createFileRoute("/cookiepolicy")({
  head: () => ({
    meta: [
      { title: "Cookiepolicy | BBN Nordic" },
      { name: "description", content: "Information om cookies på bbnnordic.se — vilka cookies vi använder, varför och hur du kan hantera dem." },
      { property: "og:title", content: "Cookiepolicy | BBN Nordic" },
      { property: "og:description", content: "Så använder BBN Nordic cookies på webbplatsen." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://bbnnordic.se/cookiepolicy" },
      { property: "og:image", content: "https://bbnnordic.se/og-default.jpg" },
    ],
    links: [{ rel: "canonical", href: "https://bbnnordic.se/cookiepolicy" }],
  }),
  component: () => (
    <ContentPage
      eyebrow="JURIDISKT"
      title="Cookiepolicy"
      subtitle="Vilka cookies vi använder och hur du kan hantera dem."
      heroImage={IMAGES.dekorfolieHero}
      breadcrumbs={[{ label: "Cookiepolicy" }]}
      sections={[
        {
          eyebrow: "VAD ÄR COOKIES?",
          heading: "Små textfiler i din webbläsare.",
          paragraphs: [
            "Cookies är små textfiler som lagras på din enhet när du besöker en webbplats. De gör att webbplatsen kan komma ihåg dina val och samla in statistik om hur sidan används.",
          ],
        },
        {
          eyebrow: "COOKIES VI ANVÄNDER",
          heading: "Nödvändiga och analytiska cookies.",
          bullets: [
            "Nödvändiga cookies — krävs för att webbplatsen ska fungera",
            "Analytiska cookies — hjälper oss förstå hur webbplatsen används",
            "Funktionscookies — kommer ihåg dina val och inställningar",
          ],
        },
        {
          eyebrow: "HANTERA COOKIES",
          heading: "Du bestämmer själv.",
          paragraphs: [
            "Du kan när som helst ändra eller återkalla ditt samtycke via cookie-bannern. Du kan också blockera eller radera cookies via inställningarna i din webbläsare.",
            "Observera att om du blockerar nödvändiga cookies kan delar av webbplatsen sluta fungera korrekt.",
          ],
        },
      ]}
      related={[
        { to: "/integritetspolicy", label: "Integritetspolicy", desc: "Så behandlar vi dina personuppgifter." },
        { to: "/kontakt", label: "Kontakt", desc: "Frågor om vår cookiehantering?" },
      ]}
    />
  ),
});
